// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_WBV","cls2":"ReferenceEvaluationPage-cls2__Gy ReferenceEvaluationPage-cls1_WBV"};